import { render, staticRenderFns } from "./PolygonsCanvas.vue?vue&type=template&id=7987a5b6&scoped=true&"
import script from "./PolygonsCanvas.vue?vue&type=script&lang=js&"
export * from "./PolygonsCanvas.vue?vue&type=script&lang=js&"
import style0 from "./PolygonsCanvas.vue?vue&type=style&index=0&id=7987a5b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7987a5b6",
  null
  
)

export default component.exports